var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.65409 3.07291C1.52207 3.03809 1.41234 2.94642 1.35458 2.8227C1.29682 2.69898 1.297 2.556 1.35506 2.43243L2.37378 0.264406C2.4497 0.102843 2.61222 -0.000220032 2.79073 3.52743e-07C2.96924 0.000221548 3.13151 0.103687 3.20703 0.265437L3.65643 1.22802C3.67249 1.2217 3.68908 1.21623 3.70615 1.21165C6.37285 0.497114 9.11389 2.07965 9.82843 4.74635C10.543 7.41305 8.96043 10.1541 6.29373 10.8686C3.62703 11.5832 0.885997 10.0006 0.171457 7.33393C-0.0557634 6.48593 -0.0506518 5.62907 0.148358 4.83241C0.209937 4.58591 0.459691 4.43599 0.706198 4.49757C0.952704 4.55915 1.10262 4.80891 1.04104 5.05541C0.878918 5.70439 0.87445 6.40249 1.06022 7.09579C1.64323 9.27164 3.87974 10.5629 6.05559 9.97986C8.23144 9.39685 9.52269 7.16034 8.93967 4.98449C8.36618 2.84422 6.19284 1.55986 4.05107 2.07331L4.50449 3.04452C4.58001 3.20627 4.55514 3.39711 4.44069 3.5341C4.32624 3.67109 4.14288 3.72952 3.97027 3.68398L1.65409 3.07291Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetCode);
export default __webpack_public_path__ + "static/media/ResetCode.e1817ddc3a97cc4bccd65eeecef36bec.svg";
export { ForwardRef as ReactComponent };